
namespace RioERP.Reports {

    @Serenity.Decorators.registerClass()
    export class ReferralOrderProductsDialog extends Serenity.EntityDialog<ReferralOrderProductsRow, any> {
        protected getFormKey() { return ReferralOrderProductsForm.formKey; }
        protected getIdProperty() { return ReferralOrderProductsRow.idProperty; }
        protected getLocalTextPrefix() { return ReferralOrderProductsRow.localTextPrefix; }
        protected getNameProperty() { return ReferralOrderProductsRow.nameProperty; }
        protected getService() { return ReferralOrderProductsService.baseUrl; }
        protected getDeletePermission() { return ReferralOrderProductsRow.deletePermission; }
        protected getInsertPermission() { return ReferralOrderProductsRow.insertPermission; }
        protected getUpdatePermission() { return ReferralOrderProductsRow.updatePermission; }

        protected form = new ReferralOrderProductsForm(this.idPrefix);
        protected getToolbarButtons() {
            let buttons = super.getToolbarButtons();
            //debugger;
            buttons.splice(0, 3);


            return buttons;
        }
    }
}